module.exports = __webpack_public_path__ + "krecove-zily_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_3_after.jpg
// module id = 1029
// module chunks = 0